import { FC, useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Icon, Tooltip } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import { getFileResult } from '@/infra/services/uploadFile'
import * as S from './styles'

export const ListItems: FC<any> = ({
  currentFile,
  indexvalue,
  labelWidth,
  labelHeight,
  removeFromBuffer,
  updateStatus,

  error_message = ''
}) => {
  const { locale } = useRouterPush()
  const [queryCount, setQueryCount] = useState(0)
  const [completed, setCompleted] = useState(0)
  const { data, isPending, isSuccess, isError, dataUpdatedAt, errorUpdatedAt, refetch } = useQuery({
    queryKey: ['preview-result-label-library', currentFile?.item?.preflight_hash],
    queryFn: () =>
      getFileResult(
        locale,
        currentFile?.item?.preflight_hash || '',
        currentFile?.item?.page || 1,
        labelWidth,
        labelHeight
      ),
    enabled: !!currentFile?.item?.preflight_hash && !!currentFile?.item?.page,
    refetchOnWindowFocus: false
  })

  // v5 removed onSuccess/onError from useQuery; react to each fetch result instead
  useEffect(() => {
    if (!isSuccess) return
    const result: any = data
    setQueryCount((prev) => prev + 1)
    if (result.pending == 1) {
      refetch()
    } else {
      result.width === labelWidth && result.height === labelHeight
        ? updateStatus(currentFile['name'], true)
        : updateStatus(currentFile['name'], false)
    }
  }, [isSuccess, dataUpdatedAt])

  useEffect(() => {
    if (!isError) return
    console.log('on Error')
    updateStatus(currentFile['name'], false)
  }, [isError, errorUpdatedAt])

  useEffect(() => {
    if (currentFile?.progress === 100) {
      setCompleted(100)
    }
  }, [currentFile?.progress])
  return (
    <>
      <S.UList key={indexvalue}>
        <a href='javascript:void(0)' onClick={() => removeFromBuffer(indexvalue)} className='ul-list-close'>
          <Icon name='close-circle-s' />
        </a>
        <S.UListItem>
          <Icon name='pdf-cco' size='s6' />
        </S.UListItem>
        <S.UListItem>
          <p>{currentFile?.name}</p>
        </S.UListItem>
        {isPending || currentFile?.status === 'checking' ? (
          <S.SmallLoader>
            <img src='/icons/loading-small.svg' alt='checking file properties' />
          </S.SmallLoader>
        ) : (
          <S.ResultSlot>
            {currentFile?.isValid ? (
              <>
                <img src='/icons/checked.svg' alt='Valid' />
              </>
            ) : (
              <>
                <S.Hint>
                  <Tooltip title={error_message}>
                    <img src='/icons/error.svg' alt='Invalid' />
                  </Tooltip>
                </S.Hint>
              </>
            )}
          </S.ResultSlot>
        )}
        <>
          {currentFile?.status == 'completed' && (
            <>
              <S.ProgressContainer>
                <S.ProgressBar percent={completed} />
              </S.ProgressContainer>
              <S.ProgressText></S.ProgressText>
            </>
          )}
        </>
      </S.UList>
    </>
  )
}

ListItems.displayName = 'ListItems'
